import { SHOPIFY_CUSTOMER_GID_PREFIX } from '@didaskill/domain/users/constants';

/**
 * Shortens a student reference for display.
 *
 * E-commerce accounts carry a Shopify global id, whose only readable part is the customer id at the
 * very end. References coming from any other origin are left untouched.
 *
 * @param studentRef - Raw student reference, as stored on the account.
 * @returns The customer id for a Shopify reference, the reference itself otherwise.
 */
export function formatStudentRef(studentRef: string): string {
  if (!studentRef.startsWith(SHOPIFY_CUSTOMER_GID_PREFIX)) {
    return studentRef;
  }

  const customerId = studentRef.slice(SHOPIFY_CUSTOMER_GID_PREFIX.length);

  // A prefix with nothing behind it is not a usable id: better show the raw reference than nothing.
  return customerId || studentRef;
}
